import { lazy ,useEffect ,Suspense } from "react";
import { Route,Routes } from "react-router-dom";
const Profilo = lazy(()=> import('@routes/profilo/Profilo'));
const Home = lazy(()=> import("@routes/home/Home"));
const Transazioni = lazy(()=> import("@routes/transazioni/Transazioni"));
const Agenti = lazy(()=> import("@routes/agenti/Agenti"));
const Clienti = lazy(()=> import("@routes/clienti/Clienti"));
const Contratti = lazy(()=> import("@routes/contratti/Contratti"));
const Leads = lazy(()=> import("@routes/leads/Leads"));

function Main(){

    useEffect(() => {

      let title =window.location.pathname.split('/')[1]
      
      title=title.charAt(0).toUpperCase()+title.slice(1)
      if (!title) title = 'Home'
      document.title = 'JataPay - '+title;
  }, [location.pathname]);

    return <main>
    <Routes>
            <Route path="/transazioni" element={<Suspense fallback={<></>}><Transazioni/></Suspense>}/>
            <Route path="/agenti" element={<Suspense fallback={<></>}><Agenti/></Suspense>}/>
              <Route path="/clienti" element={<Suspense fallback={<></>}><Clienti/></Suspense>}/>
              <Route path="/profilo" element={<Suspense fallback={<></>}><Profilo/></Suspense>}/>
              <Route path="/contratti" element={<Suspense fallback={<></>}><Contratti/></Suspense>}/>
              <Route path="/leads" element={<Suspense fallback={<></>}><Leads/></Suspense>}/>

      

      <Route path="/transazioni" element={<Suspense fallback={<></>}><Transazioni/></Suspense>}/>
      <Route path='/' element={<Suspense fallback={<></>}><Home/></Suspense>}/>
      <Route path='/home' element={<Suspense fallback={<></>}><Home/></Suspense>}/>
      <Route path='/home/:role' element={<Suspense fallback={<></>}><Home/></Suspense>}/>
      <Route path={'*'} element={<Suspense fallback={<></>}><Home/></Suspense>}/> {/* 404 */}
    
    
    
    

  </Routes>

    </main>

}export default Main

